import { firebaseFirestore } from 'services/firebase';

export const getMembersWithCities = async snapshot => {
  const membersPromises = snapshot.docs.map(async doc => {
    let city = '';
    if (doc.data().city && doc.data().city !== '') {
      const cityRef = await firebaseFirestore.collection('cities').doc(doc.data().city);
      const citySnapshot = await cityRef.get();

      if (citySnapshot.data() && citySnapshot.data().name) {
        city = citySnapshot.data().name || '';
      }
    }

    return { ...doc.data(), city };
  });

  const members = await Promise.all(membersPromises);

  return members;
};
